import { addHours } from 'date-fns'
import { pad } from './utils.js'

let $pickers = Array.from(document.querySelectorAll('.js-date-picker'))

let promises = $pickers.map(init)
Promise.all(promises).then(p => {
  p.forEach(pika => {
    onSelect.bind(pika)()
  })
})

let pikas = {}

function init($picker) {
  return Promise.all([
    import(/* webpackChunkName: 'pikaday' */ 'pikaday'),
    import(/* webpackChunkName: 'pikadaycss' */ '../css/pikaday.css')
  ]).then(([Pikaday]) => {
    let minDate = $picker.getAttribute('data-min')
    if (minDate === 'today') {
      minDate = new Date()
    } else if (minDate !== null) {
      minDate = new Date(minDate)
    }

    let maxDate = $picker.getAttribute('data-max')
    if (maxDate === 'today') {
      maxDate = new Date()
    } else if (maxDate !== null) {
      maxDate = new Date(maxDate)
    }

    let options = {
      field: $picker,
      trigger: document.getElementById($picker.getAttribute('data-trigger')),
      minDate,
      maxDate,
      toString(date) {
        return `${pad('00', date.getDate())}/${pad(
          '00',
          date.getMonth() + 1
        )}/${date.getFullYear()}`
      },
      parse(str) {
        let [day, month, year] = str.split('/')
        return new Date(
          parseInt(year, 10),
          parseInt(month, 10) - 1,
          parseInt(day, 10)
        )
      },
      onDraw(e) {
        e.el.setAttribute('data-month', e.calendars[0].month)
        e.el.classList[isLeapYear(e.calendars[0].year) ? 'add' : 'remove'](
          'is-leapyear'
        )
      },
      onSelect
    }

    let initialDate
    try {
      let [day, month, year] = $picker.value.split('/')
      initialDate = new Date(
        parseInt(year, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10)
      )
    } catch (_) { }


    console.log('yeh')
    let d = $picker.getAttribute('data-initial')
    if (d) {
      initialDate = addHours(new Date(), parseInt(d, 10))
    }


    if (isValidDate(initialDate)) {
      options.defaultDate = initialDate
      options.setDefaultDate = true
    }

    pikas[$picker.id] = new Pikaday(options)

    return pikas[$picker.id]
  })
}

function onSelect() {
  let date = this.getDate()
  if (date === null) return

  let start = this._o.field.getAttribute('data-start')
  if (start) {
    pikas[start].setEndRange(date)
    pikas[start].setMaxDate(date)
    this.setEndRange(date)

    this.el.classList.add('has-endrange')
    pikas[start].el.classList.add('has-endrange')
  } else {
    let end = this._o.field.getAttribute('data-end')
    if (end) {
      this.setStartRange(date)
      pikas[end].setStartRange(date)
      pikas[end].setMinDate(date)
      if (pikas[end].getDate() === null) {
        pikas[end].gotoDate(date)
      }

      this.el.classList.add('has-startrange')
      pikas[end].el.classList.add('has-startrange')
    }
  }
}

function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d)
}



// WEBPACK FOOTER //
// ./src/js/_date-picker.js